"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../baseComponents/Button"));
var _index = require("../../index");
var _utils = require("../../utils/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TodoItem = function TodoItem(props) {
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    extraBtnClass = _useState2[0],
    setExtraBtnClass = _useState2[1];
  function handleMouseHover() {
    setExtraBtnClass("hover");
  }
  function handleMouseLeave() {
    setExtraBtnClass("");
  }
  function handleOnClick(e) {
    //Only those 2 case needs to stop the primary action, otherwise any click should trigger the action
    if (e.target.tagName === "A" || e.target.parentElement.tagName === "A" || e.target.tagName === "BUTTON" && !e.target.className.includes("primaryBtn") || e.target.parentElement.tagName === "BUTTON" && !e.target.parentElement.className.includes("primaryBtn")) {
      return;
    } else {
      e.preventDefault();
      props.action();
    }
  }
  var componentClasses = (0, _classnames["default"])("todoItem-component", props.className, props.theme, props.type, {
    "focused": props.focused
  });
  var btnTheme = "teal";
  if (props.theme === "grey") btnTheme = "purple";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: componentClasses,
    style: props.style,
    onMouseEnter: handleMouseHover,
    onMouseLeave: handleMouseLeave,
    onClick: handleOnClick
  }, /*#__PURE__*/_react["default"].createElement(_index.FullBar, {
    left: /*#__PURE__*/_react["default"].createElement("div", {
      className: "todoContent"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "topContent"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "title"
    }, /*#__PURE__*/_react["default"].createElement("p", null, props.title)), props.text && /*#__PURE__*/_react["default"].createElement("p", {
      className: "text"
    }, props.text), props.subText && /*#__PURE__*/_react["default"].createElement("p", {
      className: "mice"
    }, props.subText)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "bottomContent"
    }, props.extraLeftContent && /*#__PURE__*/_react["default"].createElement("div", {
      className: "extraLeftContent"
    }, props.extraLeftContent), props.action && props.type === "ext-1" && /*#__PURE__*/_react["default"].createElement("div", {
      className: "buttonContent"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      radius: "square",
      shapeStyle: "stroke",
      text: props.cta,
      colorTheme: btnTheme,
      size: "small",
      className: "".concat(extraBtnClass, " primaryBtn")
    }), props.extraButtonContent && /*#__PURE__*/_react["default"].createElement("div", {
      className: "extraButtonContent"
    }, props.extraButtonContent)))),
    right: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.extraRightContent && /*#__PURE__*/_react["default"].createElement("div", {
      className: "extraRightContent"
    }, props.extraRightContent), props.action && props.type === "default" && /*#__PURE__*/_react["default"].createElement("div", {
      className: "buttonContent"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      radius: "square",
      shapeStyle: "stroke",
      text: props.cta,
      colorTheme: btnTheme,
      size: "small",
      className: "".concat(extraBtnClass, " primaryBtn")
    }), props.extraButtonContent && /*#__PURE__*/_react["default"].createElement("div", {
      className: "extraButtonContent"
    }, props.extraButtonContent)))
  }));
};
TodoItem.propTypes = {
  type: _propTypes["default"].oneOf(["default", "ext-1"]),
  theme: _propTypes["default"].oneOf(['white', 'grey']),
  cta: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  extraLeftContent: _propTypes["default"].any,
  extraRightContent: _propTypes["default"].any,
  action: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  subText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  focused: _propTypes["default"].bool
};
TodoItem.defaultProps = {
  type: "default",
  theme: "white",
  title: "",
  text: "",
  subText: "",
  cta: "",
  action: null,
  className: "",
  style: {},
  extraLeftContent: null,
  extraRightContent: null,
  extraButtonContent: null,
  focused: false
};
var _default = exports["default"] = TodoItem;